import { dwCollect } from '@/utils/dw-collect';

export const dwBannerCloseClick = () => {
  dwCollect({ module: 'banner', element: 'close', action: 'click' });
};

/**
 * Banner点击
 */
export const dwBannerClick = () => {
  dwCollect({ module: 'banner', action: 'click' });
};

/**
 * Banner展示
 */
export const dwBannerShow = () => {
  dwCollect({ module: 'banner', action: 'show' });
};

/**
 * hover【立即咨询】
 */
export const dwBannerQrCodeHover = () => {
  dwCollect({ module: 'banner', element: 'qrcode', action: 'hover' });
};
